import { List, Map } from 'immutable'
import { combineReducers } from 'redux'
import wopi360Service from '../services/wopi360'

const FETCH = 'wopi360-target/FETCH'
const FETCH_SUCCESS = 'wopi360-target/FETCH_SUCCESS'

const SEND_INVITATIONS = 'wopi360-target/SEND_INVITATIONS'
const SEND_INVITATIONS_SUCCESS = 'wopi360-target/SEND_INVITATIONS_SUCCESS'
const SEND_INVITATIONS_FAILURE = 'wopi360-target/SEND_INVITATIONS_FAILURE'

const FETCH_DETAILS = 'wopi360-target/FETCH_DETAILS'
const FETCH_DETAILS_SUCCESS = 'wopi360-target/FETCH_DETAILS_SUCCESS'
const FETCH_DETAILS_FAILURE = 'wopi360-target/FETCH_DETAILS_FAILURE'

const SET_SENT_INVITATIONS = 'wopi360-target/SET_SENT_INVITATIONS'

const CLOSE_TARGET = 'wopi360-target/CLOSE_TARGET'
const CLOSE_TARGET_SUCCESS = 'wopi360-target/CLOSE_TARGET_SUCCESS'
const CLOSE_TARGET_FAILURE = 'wopi360-target/CLOSE_TARGET_FAILURE'

const DELETE_INVITATION = 'wopi360-target/DELETE_INVITATION'
const DELETE_INVITATION_SUCCESS = 'wopi360-target/DELETE_INVITATION_SUCCESS'
const DELETE_INVITATION_FAIL = 'wopi360-target/DELETE_INVITATION_FAIL'

const SEND_REMINDERS_PENDING = 'wopi360-target/SEND_REMINDERS_PENDING'
const SEND_REMINDERS_SUCCESS = 'wopi360-target/SEND_REMINDERS_SUCCESS'
const SEND_REMINDERS_FAILURE = 'wopi360-target/SEND_REMINDERS_FAILURE'

const targetDefaultState = Map({
  target: null,
  isLoading: false
})

function targetReducer(state = targetDefaultState, action = undefined) {
  switch (action.type) {
    case FETCH:
      return state.update('isLoading', isLoading => true)

    case FETCH_SUCCESS:
      return state
        .update('isLoading', isLoading => false)
        .update('target', target => action.payload)

    default:
      return state
  }
}

function targetDetailsReducer(state = null, action = undefined) {
  switch (action.type) {
    case FETCH_DETAILS_SUCCESS:
      return action.payload

    case CLOSE_TARGET_SUCCESS:
      return Object.assign({}, state, {
        closedAt: action.payload.closedAt
      })

    default:
      return state
  }
}

function sentInvitationsReducer(state = List(), action = undefined) {
  switch (action.type) {
    case SET_SENT_INVITATIONS:
      return List(action.payload)

    default:
      return state
  }
}

function deletedInvitationsReducer(state = List(), action = undefined) {
  switch (action.type) {
    case DELETE_INVITATION_SUCCESS:
      return state.push(action.payload.invitationUuid)

    default:
      return state
  }
}

function sentRemindersReducer(state = List(), action = undefined) {
  switch (action.type) {
    case SEND_REMINDERS_SUCCESS:
      return state.concat(action.payload)

    default:
      return state
  }
}

export default combineReducers({
  target: targetReducer,
  targetDetails: targetDetailsReducer,
  sentInvitations: sentInvitationsReducer,
  deletedInvitations: deletedInvitationsReducer,
  sentReminders: sentRemindersReducer
})

export function getWopi360Target(uuid) {
  return dispatch => {
    dispatch({ type: FETCH, payload: { uuid } })

    return wopi360Service.getWopi360Target(uuid).then(response => {
      dispatch({
        type: FETCH_SUCCESS,
        payload: { ...response.data.target, units: response.data.units }
      })
    })
  }
}

export function getWopi360TargetDetails(uuid) {
  return dispatch => {
    dispatch({ type: FETCH_DETAILS })

    return wopi360Service
      .getWopi360TargetDetails(uuid)
      .then(response => dispatch({ type: FETCH_DETAILS_SUCCESS, payload: response.data }))
      .catch(e => dispatch({ type: FETCH_DETAILS_FAILURE, payload: e }))
  }
}

export function sendInvitations(uuid, language, recipients, message, manager) {
  const emails = manager.length > 0 ? recipients.concat(manager) : recipients

  return dispatch => {
    dispatch({ type: SEND_INVITATIONS, payload: { uuid, language, recipients, message, manager } })

    return wopi360Service
      .sendWopi360Invitations(uuid, language, recipients, message, manager)
      .then(response => {
        dispatch({ type: SEND_INVITATIONS_SUCCESS, payload: response.data })

        dispatch({
          type: SET_SENT_INVITATIONS,
          payload: List(emails)
        })

        getWopi360TargetDetails(uuid)(dispatch)

        setTimeout(() => dispatch({ type: SET_SENT_INVITATIONS, payload: List() }), 10000)
      })
      .catch(e => {
        dispatch({ type: SEND_INVITATIONS_FAILURE, payload: e })
      })
  }
}

export function closeWopi360Target(uuid) {
  return dispatch => {
    dispatch({ type: CLOSE_TARGET })

    return wopi360Service
      .closeWopi360Target(uuid)
      .then(response =>
        dispatch({
          type: CLOSE_TARGET_SUCCESS,
          payload: {
            uuid,
            closedAt: response.data.closedAt
          }
        })
      )
      .catch(e => dispatch({ type: CLOSE_TARGET_FAILURE, payload: e }))
  }
}

export function deleteInvitation(organisationId, targetUuid, invitationUuid) {
  return dispatch => {
    dispatch({ type: DELETE_INVITATION, payload: { invitationUuid } })

    return wopi360Service
      .deleteWopi360(organisationId, targetUuid, invitationUuid)
      .then(() => {
        dispatch({ type: DELETE_INVITATION_SUCCESS, payload: { invitationUuid } })
      })
      .catch(e => dispatch({ type: DELETE_INVITATION_FAIL, payload: e }))
  }
}

export function sendReminders(organisationId, targetUuid, wopi360Uuids) {
  return dispatch => {
    dispatch({ type: SEND_REMINDERS_PENDING, payload: List() })

    return wopi360Service
      .sendWopi360ReminderMails(organisationId, targetUuid, wopi360Uuids)
      .then(response => {
        dispatch({ type: SEND_REMINDERS_SUCCESS, payload: List(response.data) })
      })
      .catch(e => dispatch({ type: SEND_REMINDERS_FAILURE, payload: e }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/wopi360-target.js